module.exports = __webpack_public_path__ + "static/img/pngwave.9cf3a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngwave.png
// module id = 60vo
// module chunks = 1